/**
 * Add external link attributes for external links, and
 * add download attribute for uploads links.
 */
class Links {
  constructor() {
    this.initLinks();
  }

  initLinks() {
    const allLinks = Array.from(document.querySelectorAll('a'));

    if (allLinks.length > 0) {
      allLinks.forEach(link => {
        this.setExternal(link);
      });
    }
  }

  /**
   * Add rel and target attributes for links that should open
   * in a new tab.
   *
   * @param {object} link
   */
  setExternal(link) {
    if (
      link.host !== window.location.host ||
      link.href.includes('/wp-content/uploads/') ||
      link.classList.contains('js-external-link')
    ) {
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('target', '_blank');
    }
  }
}

export default Links;
